import * as ChannelService from '@channel.io/channel-web-sdk-loader'
import { useContext, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import dayjs from 'dayjs'
import styled from 'styled-components'

import { toast, clipboardCopy } from '../../utils'
import { abrViewContentDetails } from '../../utils/abr'
import { useNavigate } from '../../hooks/useNavigate'

import { StoresContext } from '../../provider/StoreProvider'

import useParamId from '../../hooks/useParamId'

import { Wrap } from '../../components/container/Wrap'
import { Content } from '../../components/container/Content'
import { RowBetween } from '../../components/common'
import { Header } from '../../components/header'
import { ArtipioContentsHeader, ArtipioContents, ArtipioContentItem } from '../../components/contents'

import { ReactComponent as HomeIcon } from '../../assets/ico/detail/home_black.svg'
import { ReactComponent as ShareIcon } from '../../assets/ico/detail/share_black.svg'

export const ContentDetail = observer(() => {
  const { commonStore, artfairStore } = useContext(StoresContext)
  const detailStore = artfairStore.artMuseumDetailStore

  const navigate = useNavigate()
  const paramId = useParamId()

  const isLastImg =
    detailStore.content?.contents[(detailStore.content?.contents?.length as number) - 1]?.type === 'image'

  useEffect(() => {
    commonStore.setShowTab(false)
  }, [])

  useEffect(() => {
    if (typeof paramId === 'undefined') return

    try {
      const loadData = async () => {
        await detailStore.load({ param: { articleId: paramId } }, true)
        abrViewContentDetails(detailStore?.content ?? {}, detailStore?.content?.category ?? {})
        ChannelService.track('view_content_details')
      }
      loadData()
    } catch (error) {
      toast('페이지를 불러오는데 실패했습니다.', error)
    }
  }, [paramId])

  const goHome = () => navigate('/home')

  const copyUrl = () => clipboardCopy(window.location.href, { message: '콘텐츠 페이지 주소가 복사되었어요.' })

  return (
    <Wrap>
      <Header
        type="SUB"
        title=""
        rightItem={
          <HeaderRightItem $gap={16}>
            <ShareIcon onClick={copyUrl} />
            <HomeIcon onClick={goHome} />
          </HeaderRightItem>
        }
      />
      <StyledContent isLastImg={isLastImg}>
        <ArtipioContentsHeader>
          <ArtipioContentsHeader.Title>{detailStore.content?.title}</ArtipioContentsHeader.Title>
          <ArtipioContentsHeader.Date>
            {dayjs(detailStore.content?.createdDate).format('YYYY-MM-DD')}
          </ArtipioContentsHeader.Date>
        </ArtipioContentsHeader>
        <ArtipioContents>
          {detailStore.content?.contents.map(({ type, content, prop }, i) => {
            const isFirstImg = type === 'image' && i === 0
            const isLastImg = type === 'image' && i === Number(detailStore.content?.contents?.length) - 1
            return (
              <ArtipioContentItem
                key={i}
                type={type}
                content={content}
                prop={prop}
                isFirstImg={isFirstImg}
                isLastImg={isLastImg}
              />
            )
          })}
        </ArtipioContents>
      </StyledContent>
    </Wrap>
  )
})

const HeaderRightItem = styled(RowBetween)`
  > * {
    cursor: pointer;
  }
`

const StyledContent = styled(Content)<{ isLastImg: boolean }>`
  ${({ isLastImg }) => (isLastImg ? '' : 'padding-bottom: 108px;')}
`
